import React from 'react';
import styled from 'styled-components';
import { Table } from 'rbx';
import gql from 'graphql-tag';
import swal from 'sweetalert';

import { useMutation } from '@apollo/react-hooks';
import { useStoreState } from 'easy-peasy';
import { isNil } from 'lodash';
import { toast } from 'react-toastify';

import { Table as CustomTable, Box } from '../../../components/elements';

import List from './List';
import AddEditForm from './AddEditForm';
import client from '../../../utils/apolloClient';

const Container = styled.div`
  .table-container {
    min-height: 30rem;
  }
`;

const createCmsPageActionMutation = gql`
  mutation createCmsPageActionMutation($input: CreateCmsPageActionInput) {
    create_cms_page_action(input: $input) {
      api_actions {
        api_action_id
        name
      }
      description
      menu
      menu_page
      name
      page_action_id
      error {
        code
        description
      }
    }
  }
`;

const updateCmsPageActionMutation = gql`
  mutation updateCmsPageActionMutation($input: UpdateCmsPageActionInput) {
    update_cms_page_action(input: $input) {
      api_actions {
        api_action_id
        name
      }
      description
      menu
      menu_page
      name
      page_action_id
      error {
        code
        description
      }
    }
  }
`;

const deleteCmsPageActionMutation = gql`
  mutation deleteCmsPageActionMutation($input: DeleteCmsPageActionInput) {
    delete_cms_page_action(input: $input) {
      api_actions {
        api_action_id
        name
      }
      description
      menu
      menu_page
      name
      page_action_id
      error {
        code
        description
      }
    }
  }
`;

const Details = ({ pageActions, activeModalProp, refetch }) => {
  const { userId } = useStoreState(state => state.auth);

  const {
    selectedPageAction,
    setSelectedPageAction,
    isActiveModal,
    setIsActiveModal,
  } = activeModalProp;

  const [createPageAction, { loading }] = useMutation(
    createCmsPageActionMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ create_cms_page_action }) => {
        if (!isNil(create_cms_page_action.error)) {
          create_cms_page_action.error.map(item =>
            toast.error(item.description),
          );
        } else {
          swal('Successfully added page action!').then(() => {
            setIsActiveModal(false);
            refetch();
          });
        }
      },
    },
  );

  const [updatePageAction, { loading: loading2 }] = useMutation(
    updateCmsPageActionMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ update_cms_page_action }) => {
        if (!isNil(update_cms_page_action.error)) {
          update_cms_page_action.error.map(item =>
            toast.error(item.description),
          );
        } else {
          swal('Successfully updated page action!').then(() => {
            setIsActiveModal(false);
            refetch();
            setSelectedPageAction(null);
          });
        }
      },
    },
  );

  const [deletePageAction, { loading: isDeleting }] = useMutation(
    deleteCmsPageActionMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ delete_cms_page_action }) => {
        if (!isNil(delete_cms_page_action.error)) {
          delete_cms_page_action.error.map(item =>
            toast.error(item.description),
          );
        } else {
          swal('Successfully deleted page action!').then(() => {
            refetch();
            setSelectedPageAction(null);
          });
        }
      },
    },
  );

  return (
    <React.Fragment>
      <Box>
        <Container>
          <CustomTable>
            <Table.Head>
              <Table.Row>
                <Table.Heading>Name</Table.Heading>
                <Table.Heading>Description</Table.Heading>
                <Table.Heading>Actions</Table.Heading>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              <List
                pageActions={pageActions}
                onEdit={value => {
                  setSelectedPageAction(value);
                  setIsActiveModal(true);
                }}
                onDelete={async value => {
                  deletePageAction({
                    variables: {
                      input: {
                        page_action_id: value?.page_action_id,
                        user_id: userId,
                      },
                    },
                  });
                }}
                isDeleting={isDeleting}
              />
            </Table.Body>
          </CustomTable>
        </Container>
      </Box>
      {isActiveModal && (
        <AddEditForm
          pageAction={selectedPageAction}
          loading={loading || loading2}
          isActive={isActiveModal}
          onClose={() => setIsActiveModal(false)}
          onSubmit={values => {
            if (selectedPageAction) {
              updatePageAction({
                variables: {
                  input: {
                    page_action_id: selectedPageAction?.page_action_id,
                    user_id: userId,
                    name: values.name,
                    description: values.description,
                    api_action_ids: values.api_actions,
                    menu_page: values.menu_page,
                    menu: values.menu,
                  },
                },
              });
            } else {
              createPageAction({
                variables: {
                  input: {
                    user_id: userId,
                    name: values.name,
                    description: values.description,
                    api_action_ids: values.api_actions,
                    menu_page: values.menu_page,
                    menu: values.menu,
                  },
                },
              });
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Details;
